var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content_heading" }, [
    _c("h3", [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("a", {
      class: _vm.setBookmark,
      attrs: { title: _vm.$t("sdl.myMenu.label.favorite.title") },
      on: { click: _vm.modifyUserQuickMenu }
    }),
    _vm._v(" "),
    _vm.isResourceTypes
      ? _c(
          "button",
          {
            staticClass: "st_label ico_info_circle",
            staticStyle: {
              top: "8px",
              padding: "12px 6px 12px 25px",
              "font-size": "14px",
              "margin-left": "15px"
            },
            on: {
              click: function($event) {
                return _vm.resourceTypesPopup()
              }
            }
          },
          [_vm._v("Resource Types")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.titleButtonShow
      ? _c("div", { staticClass: "button" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-secondary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.deRegisterMachinePopup()
                }
              }
            },
            [_vm._v("\n      " + _vm._s("De-register Machine") + "\n    ")]
          ),
          _vm._v(" "),
          !_vm.webClientSocketConnectionState
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-secondary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.clientConnect()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s("Try Client Connection") + "\n    "
                  )
                ]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
      _c(
        "ol",
        { staticClass: "breadcrumb" },
        [
          _vm.home
            ? _c(
                "li",
                { staticClass: "item" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "mainIndexPage" } } },
                    [_vm._v(_vm._s(_vm.homeText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.list, function(item, index) {
            return _c(
              "li",
              {
                key: item.menuId,
                staticClass: "item",
                class: { active: index === _vm.list.length - 1 }
              },
              [_c("a", [_vm._v(_vm._s(_vm.getLabel(item)))])]
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e1ff62e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1ff62e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/breadcrumb/Breadcrumb.vue
// module id = null
// module chunks = 